
<!-- Shown on step 1 for all users-->
<!-- <app-pro-select-header
    *ngIf="(activeStep == null || (showReadyToMap && activeStep == breadcrumbs[0].value)) && routeUrl != '/data/pro/archive'"></app-pro-select-header> -->


<!-- <app-pro-import [showImportDetails]="showProImport" *ngIf="activeStep == null"></app-pro-import> -->

<!-- Shown on step 2 & category labeling for super admin -->
<!-- <app-pro-import-map-submit-header *ngIf="(activeStep == breadcrumbs[0].value || activeStep == breadcrumbs[1].value) && 
    !(showReadyToMap && activeStep == breadcrumbs[0].value) && routeUrl != '/data/pro/archive'">
</app-pro-import-map-submit-header>

<app-pro-archive-header *ngIf="routeUrl === '/data/pro/archive'"></app-pro-archive-header> -->


<router-outlet></router-outlet>


<!-- Shown on part 1 of step 1 for super admin -->
<!-- <app-super-admin-pro-import
    *ngIf="activeStep == breadcrumbs[0].value && userService?.currentUser?.is_superuser && showProImport"></app-super-admin-pro-import> -->

<!-- Shown on part 2 of step 1 for super amin -->
<!-- <app-super-admin-pro-map-labels
    *ngIf="showMapHeaders && userService?.currentUser?.is_superuser"></app-super-admin-pro-map-labels> -->

<!-- Shown at the end of step 1 -->
<!-- <app-ready-to-map *ngIf="showReadyToMap && activeStep == breadcrumbs[0].value"></app-ready-to-map> -->


<!-- Shown on step 2 -->
<!-- <app-partner-group-show-mapper *ngIf="activeStep == breadcrumbs[1].value"></app-partner-group-show-mapper> -->